import baseApi from './base.api'
import { normalizePromptResponse, normalizePromptsResponse } from './utils/normalizers/prompt.normalizers'
import { PROMPT_TAG } from './utils/tags'

export const questionApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchDefaultPrompts: builder.query({
            query: () => ({
                url: `/prompt/default`,
                method: 'GET',
            }),
            transformResponse: normalizePromptsResponse,
        }),
        fetchPromptHistory: builder.query({
            query: ({ promptName }) => ({
                url: `/prompt/${promptName}`,
                method: 'GET',
            }),
            transformResponse: normalizePromptsResponse,
            providesTags: [PROMPT_TAG],
        }),
        activateLatestPrompts: builder.mutation({
            query: () => ({
                url: `/prompt/activate-latest`,
                method: 'POST',
            }),
            invalidatesTags: [PROMPT_TAG],
        }),
        createPrompt: builder.mutation({
            query: body => ({
                url: `/prompt`,
                method: 'POST',
                body,
            }),
            transformResponse: normalizePromptResponse,
            invalidatesTags: [PROMPT_TAG],
        }),
    }),
})

export const {
    useFetchDefaultPromptsQuery,
    useFetchPromptHistoryQuery,
    useActivateLatestPromptsMutation,
    useCreatePromptMutation,
} = questionApi
